const PUBLIC_URL = process.env.PUBLIC_URL || '';
const FALLBACK_BASE_PATH = `${PUBLIC_URL}/Bank%20Logos/Bank%20Fallback%20Thumbnails`;
const RBC_VECTOR_LOGO_PATH = `${PUBLIC_URL}/Bank%20Logos/Canada/RBC.svg`;

const INSTITUTION_FALLBACKS = [
  { fileName: 'RBC.svg', assetUrl: RBC_VECTOR_LOGO_PATH, aliases: ['rbc royal bank', 'royal bank of canada', 'royal bank', 'rbc bank', 'rbc'] },
  { fileName: 'TD_Bank.png', aliases: ['td canada trust', 'toronto dominion bank', 'toronto dominion', 'td direct investing', 'td bank'] },
  { fileName: 'Scotiabank.ico', aliases: ['bank of nova scotia', 'scotia bank', 'scotiabank', 'scotia'] },
  { fileName: 'BMO.ico', aliases: ['bank of montreal', 'bmo harris', 'bmo'] },
  { fileName: 'CIBC.png', aliases: ['canadian imperial bank of commerce', 'cibc'] },
  { fileName: 'National_Bank.png', aliases: ['national bank of canada', 'banque nationale du canada', 'banque nationale', 'national bank'] },
  { fileName: 'Desjardins.png', aliases: ['desjardins'] },
  { fileName: 'Laurentian_Bank.png', aliases: ['laurentian bank of canada', 'laurentian bank'] },
  { fileName: 'ATB_Financial.png', aliases: ['atb financial', 'atb'] },
  { fileName: 'EQ_Bank.png', aliases: ['eq bank', 'equitable bank'] },
  { fileName: 'Wealthsimple.png', aliases: ['wealthsimple cash', 'wealthsimple investments', 'wealthsimple'] },
  { fileName: 'Questrade.ico', aliases: ['questrade'] },
  { fileName: 'Manulife.png', aliases: ['manulife bank', 'manulife'] },
  { fileName: 'Sun_Life.png', aliases: ['sun life financial', 'sunlife', 'sun life'] },
  { fileName: 'iA_Financial.png', aliases: ['industrial alliance', 'ia financial group', 'ia financial', 'i a financial'] },
  { fileName: 'Canaccord.png', aliases: ['canaccord genuity', 'canaccord'] },
  { fileName: 'CI_Direct.png', aliases: ['ci financial', 'ci direct investing', 'ci direct'] },
  { fileName: 'Great_West_Life.png', aliases: ['canada life', 'great west life', 'great west'] },
  { fileName: 'Chase.png', aliases: ['jpmorgan chase bank', 'jpmorgan chase', 'jp morgan chase', 'chase bank', 'chase'] },
  { fileName: 'JP_Morgan.png', aliases: ['jpmorgan', 'jp morgan'] },
  { fileName: 'Bank_of_America.png', aliases: ['bankofamerica', 'bank of america'] },
  { fileName: 'Wells_Fargo.png', aliases: ['wells fargo'] },
  { fileName: 'Citibank.png', aliases: ['citigroup', 'citi bank', 'citibank', 'citi'] },
  { fileName: 'Goldman_Sachs.png', aliases: ['goldman sachs'] },
  { fileName: 'Morgan_Stanley.png', aliases: ['morgan stanley'] },
  { fileName: 'US_Bank.ico', aliases: ['us bancorp', 'u s bank', 'u.s. bank', 'us bank'] },
  { fileName: 'PNC_Bank.png', aliases: ['pnc bank', 'pnc'] },
  { fileName: 'Capital_One.ico', aliases: ['capitalone', 'capital one'] },
  { fileName: 'American_Express.ico', aliases: ['americanexpress', 'american express', 'amex'] },
  { fileName: 'Ally_Bank.png', aliases: ['ally bank', 'ally'] },
  { fileName: 'Charles_Schwab.png', aliases: ['charles schwab', 'schwab'] },
  { fileName: 'Fidelity.png', aliases: ['fidelity investments', 'fidelity'] },
  { fileName: 'Vanguard.ico', aliases: ['vanguard'] },
  { fileName: 'BlackRock.ico', aliases: ['blackrock'] },
  { fileName: 'Merrill_Lynch.png', aliases: ['merrill edge', 'merrill lynch', 'merrill'] },
  { fileName: 'Edward_Jones.ico', aliases: ['edward jones'] },
  { fileName: 'Raymond_James.png', aliases: ['raymond james'] },
  { fileName: 'E_Trade.png', aliases: ['e trade', 'etrade', 'e trade from morgan stanley'] },
  { fileName: 'Interactive_Brokers.png', aliases: ['interactive brokers', 'ibkr'] },
  { fileName: 'Robinhood.png', aliases: ['robinhood'] },
  { fileName: 'Coinbase.png', aliases: ['coinbase'] },
  { fileName: 'Binance.png', aliases: ['binance'] },
  { fileName: 'Kraken.png', aliases: ['kraken'] },
  { fileName: 'Gemini.png', aliases: ['gemini'] },
  { fileName: 'SoFi.ico', aliases: ['sofi bank', 'social finance', 'sofi'] },
  { fileName: 'Betterment.png', aliases: ['betterment'] },
  { fileName: 'Acorns.png', aliases: ['acorns'] },
  { fileName: 'Stash.ico', aliases: ['stash'] },
  { fileName: 'Public.png', aliases: ['public investing', 'public com', 'public.com'] },
  { fileName: 'Neo_Financial.png', aliases: ['neo financial', 'neo money', 'neo'] },
  { fileName: 'PC_Financial.ico', aliases: ['presidents choice financial', 'president s choice financial', 'pc financial'] },
  { fileName: 'Tangerine.png', aliases: ['tangerine bank', 'tangerine'] },
];

export const normalizeInstitutionName = (value) => String(value || '')
  .normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/&/g, ' and ')
  .replace(/[^a-z0-9]+/g, ' ')
  .trim()
  .replace(/\s+/g, ' ');

const matchesAlias = (normalizedValue, alias) => {
  if (!normalizedValue || !alias) return false;
  const paddedValue = ` ${normalizedValue} `;
  return paddedValue.includes(` ${alias} `);
};

export const getInstitutionLogoFallbackFileName = (names) => {
  const candidates = Array.isArray(names) ? names : [names];
  const normalizedCandidates = candidates
    .map((candidate) => normalizeInstitutionName(candidate))
    .filter(Boolean);

  for (const normalizedCandidate of normalizedCandidates) {
    for (const entry of INSTITUTION_FALLBACKS) {
      if (entry.aliases.some((alias) => matchesAlias(normalizedCandidate, alias))) {
        return entry.fileName;
      }
    }
  }

  return null;
};

export const getInstitutionLogoFallbackUrl = (names) => {
  const fileName = getInstitutionLogoFallbackFileName(names);
  if (!fileName) return null;
  const matched = INSTITUTION_FALLBACKS.find((entry) => entry.fileName === fileName);
  return matched?.assetUrl || `${FALLBACK_BASE_PATH}/${encodeURIComponent(fileName)}`;
};

export default getInstitutionLogoFallbackUrl;
